var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowside(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.464625 0.714452C0.806334 0.372743 1.36035 0.372743 1.70206 0.714452L6.36873 5.38112C6.71044 5.72283 6.71044 6.27685 6.36873 6.61856L1.70206 11.2852C1.36035 11.6269 0.806334 11.6269 0.464625 11.2852C0.122917 10.9435 0.122917 10.3895 0.464625 10.0478L4.51257 5.99984L0.464625 1.95189C0.122916 1.61018 0.122916 1.05616 0.464625 0.714452Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowside);
export default __webpack_public_path__ + "static/media/arrowside.29ea72c16fe1ae352f423bcb9e796a39.svg";
export { ForwardRef as ReactComponent };